// extracted by mini-css-extract-plugin
module.exports = {"noPaddingTop":"ListPage_noPaddingTop__vK1Dp","marginTop2":"ListPage_marginTop2____hoT"};